import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { removeToken , getToken, setToken } from '@/utils/auth'
import { loadingClose } from '@/main.js'
import { apiUrl } from '@/utils/config.js'
// create an axios instance
const service = axios.create({
  baseURL: apiUrl[process.env.NODE_ENV], // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 过滤空字符串
    let data = { ...config.data,competition_id:202601 }
    for (let it in data) {
      if (data[it] === '' || data[it] === null) {
        delete data[it];
      }
    }
	console.log(data)
    config.data = data;
    let token = getToken();
    config.headers['Authorization'] = token;
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    const headers = response.headers;
    res.authToken = headers.authorization ? headers.authorization.substring(7) : "";
    if (res.authToken) {
      setToken(res.authToken,window.localStorage.getItem("remember")=="true"?true:false);
    }
    loadingClose()
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      Message({
        message: res.msg || '网络错误',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.msg || '网络错误'))
    } else {
      return res
    }
  },
  error => {
    var url = error.config.url;
    var href = window.location.hash;
    console.log(url) // for debug
    console.log(href)
    let code = error.response.status
    if (code === 401 && getToken()) {
      removeToken()
      // to re-login
      if (href == "#/") {
        return false
      }
      if (url==="api/agent/v1/logout") {
        window.location.href="/"
        return false
      }
      MessageBox.confirm('登录已经过期，是否重新登录？', '登录提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.href="/"
      }).catch(e=>{
      })
    }
    loadingClose();
    return Promise.reject(error.response);
  }
)

export default service
